import { render, staticRenderFns } from "./MarriageRecordItem.vue?vue&type=template&id=83cff1fc&"
import script from "./MarriageRecordItem.vue?vue&type=script&lang=js&"
export * from "./MarriageRecordItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports